import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "VE_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#VE_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "VE_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#VE_svg__b)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0v8h32V0H0z", fill: "#FECA00" }), /* @__PURE__ */ e.createElement("path", { d: "M0 16v8h32v-8H0z", fill: "#E31D1C" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.737 11.86l.983-.557 1.102.557-.396-1.133.824-.833h-1.048l-.484-1.072-.412 1.072h-1.23l.924.818h-1.037L11.48 9.64l-.413 1.072h-1.23l.942.832-.18.727h-.784L9.33 11.2l-.412 1.072h-1.23l.942.833-.174.703h-.343l-.484-1.073-.412 1.072h-1.23l.942.833-.281 1.133.983-.557 1.102.557-.396-1.133.824-.832h-.053l.224-.127 1.102.557-.396-1.133.472-.477-.012.05.982-.557 1.103.558-.396-1.134.818-.827.012.01-.281 1.133zM19.222 11.816l-.983-.557-1.102.557.396-1.133-.824-.832h1.048l.484-1.073.412 1.073h1.23l-.924.817h1.043l.483-1.072.412 1.072h1.23l-.941.833.18.726h.784l.484-1.072.412 1.072h1.23l-.942.833.174.703h.343l.484-1.073.412 1.073h1.23l-.942.832.28 1.133-.982-.557-1.102.557.396-1.133-.824-.832h.053l-.224-.127-1.103.557.396-1.133-.471-.477.012.05-.982-.557-1.103.557.396-1.132-.821-.83-.014.012.28 1.133z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.833 10.535l-.983.557.28-1.133-.94-.832h1.229l.412-1.072.484 1.072h1.048l-.823.832.395 1.133-1.102-.557z",
      fill: "#F7FCFF"
    }
  )))
), h = t;
export {
  h as default
};
